let API_BASE_URL = 'http://localhost:3001';
if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = 'https://cozzy-server.herokuapp.com';
}
export { API_BASE_URL };
